<ng-content select="page-header, pageHeader, [pageHeader]"></ng-content>
<ng-content select="page-content, pageContent, [pageContent]"></ng-content>
<ng-content select="page-footer, pageFooter, [pageFooter]"></ng-content>
